import React, { useState, useEffect } from 'react';

const BrandManifesto = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const manifestoLines = [
    "We were never meant to blend in.",
    "We were never meant to be muted.", 
    "Our shade is not a compromise.",
    "Our beauty isn't a trend.",
    "Our culture isn't costume.",
    "Our voice isn't \"too loud.\"",
    "We're not here to fit your mold.",
    "We're here to break it."
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % manifestoLines.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [manifestoLines.length]);

  return (
    <section className="py-20 bg-richBrown text-warmCream overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Manifesto Carousel */}
          <div className="relative h-32 sm:h-40 mb-12">
            <div className="flex items-center justify-center h-full">
              {manifestoLines.map((line, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 flex items-center justify-center transition-all duration-1000 transform ${
                    index === currentSlide 
                      ? 'opacity-100 translate-y-0' 
                      : 'opacity-0 translate-y-4'
                  }`}
                >
                  <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-center tracking-tight leading-tight px-4">
                    {line}
                  </h2>
                </div>
              ))}
            </div>
          </div>

          {/* Final Statement */}
          <div className="space-y-6">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="w-12 h-12 bg-goldAccent rounded-full flex items-center justify-center">
                <span className="text-2xl">🟤</span>
              </div>
              <h3 className="text-2xl sm:text-3xl font-black text-goldAccent tracking-wide">
                We are #Brownishh.
              </h3>
            </div>
            
            <p className="text-xl sm:text-2xl font-bold text-warmCream/90 tracking-wide">
              And we make the world look better.
            </p>
          </div>

          {/* Progress Dots */}
          <div className="flex justify-center gap-2 mt-12">
            {manifestoLines.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentSlide ? 'bg-goldAccent' : 'bg-warmCream/30'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandManifesto;